import { ApplicationState } from '..';
import { TechnicianReportState } from './reducers';

export function getTechnicianReport(state: ApplicationState, repairId: number): TechnicianReportState {
    return state.technicians.reports[repairId];
}
